import React from 'react';

export default function DrillSummary({ questions, answers, onStartAnother }) {
  const total = answers.filter(Boolean).length;
  const totalCorrect = answers.filter((a) => a && a.correct).length;
  const pct = total > 0 ? Math.round((totalCorrect / total) * 100) : 0;
  const scoreColour = pct >= 70 ? 'text-green' : pct >= 40 ? 'text-amber' : 'text-red';

  const incorrect = questions
    .map((q, i) => ({ q, a: answers[i] }))
    .filter(({ a }) => a && !a.correct);

  return (
    <div>
      <div className="text-center mb-sp-6">
        <h2 className="text-2xl font-bold text-text-primary mb-sp-1">Session complete</h2>
        <p className="text-sm text-text-muted">
          {total} drill{total === 1 ? '' : 's'} answered
        </p>
      </div>

      <div className="grid grid-cols-2 gap-sp-3 mb-sp-6">
        <div className="bg-bg-card rounded-r-xl border border-border-soft px-sp-4 py-sp-4 text-center">
          <p className="text-xs font-medium text-text-muted mb-sp-1">Score</p>
          <p className={`text-[32px] font-bold ${scoreColour}`}>
            {totalCorrect}
            <span className="text-base font-normal text-text-muted"> / {total}</span>
          </p>
        </div>
        <div className="bg-bg-card rounded-r-xl border border-border-soft px-sp-4 py-sp-4 text-center">
          <p className="text-xs font-medium text-text-muted mb-sp-1">Accuracy</p>
          <p className={`text-[32px] font-bold ${scoreColour}`}>{pct}%</p>
        </div>
      </div>

      {incorrect.length > 0 && (
        <div className="bg-bg-card rounded-r-xl border border-border-soft mb-sp-6 overflow-hidden">
          <div className="px-sp-5 py-sp-3 border-b border-border-soft text-[15px] font-semibold text-text-primary">
            Drills you got wrong
          </div>
          {incorrect.map(({ q }, i) => (
            <div
              key={q.id}
              className="px-sp-5 py-sp-3 flex items-center gap-sp-3 border-b border-border-soft last:border-b-0"
            >
              <div className="w-2 h-2 rounded-full flex-shrink-0 bg-red" />
              <div className="flex-1 min-w-0">
                <p className="text-[11px] font-semibold uppercase tracking-wider text-accent mb-[2px]">
                  {q.general_topic || q.subject_area || ''}
                </p>
                <p className="text-sm text-text-primary truncate">{q.stem}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="flex justify-center gap-sp-3 mb-sp-12">
        <button
          onClick={onStartAnother}
          className="px-sp-5 py-sp-3 text-sm font-medium bg-accent text-white rounded-r-md hover:bg-accent-hover transition-colors"
        >
          Start another session
        </button>
      </div>
    </div>
  );
}
